// extracted by mini-css-extract-plugin
export default {"greeting":"trips_greeting__QTsgk","footer":"trips_footer__CMu8r"};